export enum SearchResultsFilterGroupName {
  Companies = 'companies',
  Research = 'research',
  News = 'news',
  Search = 'search',
  Videos = 'videos',
}
